import { AddToBasketConfirmation } from './AddToBasketConfirmation.js';

var o_order = window.o_order || {};

o_order.addToBasket = o_order.addToBasket || {};
o_order.addToBasket.serverBoundaryBuilder = function () {
    'use strict';

    const server = {},
        addToBasketUrl = '/order/addToBasket';

    async function handle201(responseData, data) {
        emitAddToBasketResult(responseData, data, true);

        const sheetUrl = responseData.sheetUrl;
        if (sheetUrl.includes('/warrantySheet')) {
            await AddToBasketConfirmation.openWarranty(sheetUrl);
        } else {
            await AddToBasketConfirmation.openConfirmation(sheetUrl);
        }
    }

    async function handle409(responseData, data) {
        emitAddToBasketResult(responseData, data, false);
        await AddToBasketConfirmation.openBusinessError(responseData.sheetUrl);
    }

    async function handle422(responseData, data) {
        emitAddToBasketResult(responseData, data, false);
        await AddToBasketConfirmation.openBusinessError(responseData.sheetUrl);
    }

    async function handleDefault(responseData, data) {
        emitAddToBasketResult(responseData, data, false);
        await AddToBasketConfirmation.openTechnicalError(responseData.sheetUrl, JSON.stringify(data));
    }

    async function addToBasketWithJsonData(data) {
        const response = await fetch(addToBasketUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(data)
        });
        const responseText = await response.text();
        const responseData = o_order.utils.parseJson(responseText);
        if (responseData && 'eventMergeId' in responseData) {
            o_order.tracking.submitDummyEventMerge('add', responseData.eventMergeId);
        }
        const addToBasketId = responseData.addToBasketId;
        if (addToBasketId) {
            window.o_order.common.basketChange.triggerBasketChange();
        }

        switch (response.status) {
            case 201:
                handle201(responseData, data);
                break;
            case 409:
                handle409(responseData, data);
                break;
            case 422:
                handle422(responseData, data);
                break;
            default:
                handleDefault(responseData, data);
        }
    }

    function emitAddToBasketResult(responseData, data, isSuccessful) {
        let variationId = 'variationId' in responseData ? responseData.variationId : data.variationId;
        o_global.eventQBus.emit('ft1.order-core.addToBasketResult', {
            variationId: variationId,
            successful: isSuccessful,
            eventMergeId: responseData.eventMergeId
        });
    }

    server.addToBasket = function (data) {
        return addToBasketWithJsonData(data);
    };

    return server;
};

o_order.addToBasket.presenterBuilder = function (server) {
    'use strict';

    const presenter = {};
    window.o_global.eventQBus.on('ft1.order-core.addToBasketRequest', data => {
        presenter.addToBasket({
            variationId: data.primaryItem.variationId,
            quantity: data.primaryItem.quantity,
            services: (data.primaryItem.services ?? []).map(item => ({ uuid: item.serviceId })),
            secondaries: (data.secondaryItems ?? []).map(item => item.variationId),
            itemOrigin: data.itemOrigin,
            tracking: data.tracking || {}
        });
    });

    presenter.addToBasket = function (data) {
        server.addToBasket(data);
    };

    return presenter;
};

if (!o_order.addToBasket.initialized) {
    o_order.addToBasket.initialized = true;
    window.o_global.eventQBus.onModuleLoaded('ft1.order-core.addtobasket', ['ft1.order-core.common-public'], () => {
        const server = o_order.addToBasket.serverBoundaryBuilder();
        const presenter = o_order.addToBasket.presenterBuilder(server);

        o_order.api = o_order.api || {};
        o_order.api.addToBasket = presenter.addToBasket;
    });
}
